import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по пину новостройки на карте проектов.
 */
export function trackMapPinClick(newbuildingId: string): void {
  ca('eventSite', {
    action: 'click',
    category: 'Promo',
    label: 'project_map_pin',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
            },
          ],
        },
      }),
    ],
  });
}
